import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=18edbe74&scoped=true&"
import script from "./RadioView.vue?vue&type=script&lang=js&"
export * from "./RadioView.vue?vue&type=script&lang=js&"
import style0 from "./RadioView.vue?vue&type=style&index=0&id=18edbe74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18edbe74",
  null
  
)

export default component.exports